import { defineMessages } from 'react-intl'

export default defineMessages({
  documentsPinkSlipHeadline: {
    id: 'app.documents.pinkSlip.headline',
    defaultMessage: 'Pink Slip',
  },
  documentsPinkSlipsHeadline: {
    id: 'app.documents.pinkSlips.headline',
    defaultMessage: 'Pink Slips',
  },
  documentsEIDHeadline: {
    id: 'app.documents.eID.headline',
    defaultMessage: 'eID Card',
  },
  documentsEIDsHeadline: {
    id: 'app.documents.eIDs.headline',
    defaultMessage: 'eID Cards',
  },
  documentsPoliciesHeadline: {
    id: 'app.documents.policies.headline',
    defaultMessage: 'Policies',
  },
  documentsPolicySummaryHeadline: {
    id: 'app.documents.policySummary.headline',
    defaultMessage: 'Policy Summary',
  },
  documentsHeadline: {
    id: 'app.documents.headline',
    defaultMessage: 'My documents',
  },
  documentsSubHeadline: {
    id: 'app.documents.subHeadline',
    defaultMessage: 'Documents',
  },
  documentHeadline: {
    id: 'app.document.headline',
    defaultMessage: 'Document',
  },
  documentTagCancellation: {
    id: 'app.document.tag.cancellation',
    defaultMessage: 'Cancellation',
  },
  documentTagRenewal: {
    id: 'app.document.tag.renewal',
    defaultMessage: 'Renewal',
  },
  documentTagRewrite: {
    id: 'app.document.tag.rewrite',
    defaultMessage: 'Rewrite',
  },
  documentTagNewBusiness: {
    id: 'app.document.tag.newBusiness',
    defaultMessage: 'New Business',
  },
  documentTagPolicyChange: {
    id: 'app.document.tag.policyChange',
    defaultMessage: 'Policy change',
  },
  documentTagBillingNotice: {
    id: 'app.document.tag.billingNotice',
    defaultMessage: 'Billing notice',
  },
  documentTagInvoice: {
    id: 'app.document.tag.documentTagInvoice',
    defaultMessage: 'Invoice',
  },
  documentTagStatement: {
    id: 'app.document.tag.documentStatement',
    defaultMessage: 'Statement',
  },
  documentsDateDateAdded: {
    id: 'app.documents.date.dateAdded',
    defaultMessage: 'Date added',
  },
  documentsNoPreviewTitle: {
    id: 'app.documents.noPreview.title',
    defaultMessage: 'Unable to preview this document.',
  },
  documentsNoPreviewSubtitle: {
    id: 'app.documents.noPreview.subtitle',
    defaultMessage: 'Use the "Download" option to get the full document.',
  },
  // Policies
  policyTypeVehicle: {
    id: 'app.policy.type.vehicle',
    defaultMessage: 'Vehicle',
  },
  policyTypeProperty: {
    id: 'app.policy.type.property',
    defaultMessage: 'Property',
  },
  policyDriver: {
    id: 'app.policy.driver',
    defaultMessage: 'Driver',
  },
  policyInsurer: {
    id: 'app.policy.insurer',
    defaultMessage: 'Insurer',
  },
  policyDateEffective: {
    id: 'app.policy.date.effective',
    defaultMessage: 'Effective',
  },
  policyDateExpiry: {
    id: 'app.policy.date.expiry',
    defaultMessage: 'Expiry',
  },
  policyCreateCreatePinkSlip: {
    id: 'app.policy.create.createPinkSlip',
    defaultMessage: 'Create Pink Slip',
  },
  policyCreateSlip: {
    id: 'app.policy.create.createSlip',
    defaultMessage: 'Create',
  },
  documentPinkslip: {
    id: 'app.documents.pinkSlip.headline',
    defaultMessage: 'Pinkslip',
  },
  policyCreateCreateEIDSlip: {
    id: 'app.policy.create.createEIDSlip',
    defaultMessage: 'Create eID Card',
  },
  policyCreateCreateFleetPinkSlip: {
    id: 'app.policy.create.fleetPinkSlip',
    defaultMessage: 'Fleet Pinkslip',
  },
  policyCreateCreateFleetEIDCard: {
    id: 'app.policy.create.fleetEIDCard',
    defaultMessage: 'Fleet eID Card',
  },
  policyCreateCreateSinglePinkSlip: {
    id: 'app.policy.create.singlePinkSlip',
    defaultMessage: 'Single Pinkslip',
  },
  policyCreateCreateSingleEIDCard: {
    id: 'app.policy.create.singleEIDCard',
    defaultMessage: 'Single eID Card',
  },
  policyCreateCreateCreatesOneGenericSlip: {
    id: 'app.policy.create.createsOneGenericSlip',
    defaultMessage: 'Creates one generic pinkslip',
  },
  policyCreateCreateCreatesSingleSlipPerVehicle: {
    id: 'app.policy.create.createsSingleSlipPerVehicle',
    defaultMessage: 'Creates single pinkslip per vehicle',
  },
  policyCreateAllVehicles: {
    id: 'app.policy.create.allVehicles',
    defaultMessage: 'All vehicles',
  },
  policyCreateCreateSelected: {
    id: 'app.policy.create.createSelected',
    defaultMessage: '({selectedCount}) Selected - Create',
  },
  policyCreateCreateFleet: {
    id: 'app.policy.create.createFleet',
    defaultMessage: 'Create Fleet Slip',
  },
  policyCreateSuccessMessagePinkSlip: {
    id: 'app.policy.create.successMessagePinkSlip',
    defaultMessage:
      '{successCount, plural, one {# Pink Slip created successfully} other {# Pink Slips created successfully}}',
  },
  policyCreateSuccessMessageEIDSlip: {
    id: 'app.policy.create.successMessageEIDSlip',
    defaultMessage:
      '{successCount, plural, one {# eID Card created successfully} other {# eID Cards created successfully}}',
  },
  policyCreateSuccessMessageFleetSlip: {
    id: 'app.policy.create.successMessageFleetSlip',
    defaultMessage: 'Fleet Slip created successfully',
  },
  policyCoverageDetails: {
    id: 'app.policy.coverage.details',
    defaultMessage: 'Coverage Details',
  },
  // Policy tags
  policyTagValid: {
    id: 'app.policy.tag.valid',
    defaultMessage: 'Valid',
  },
  policyTagCancelled: {
    id: 'app.policy.tag.cancelled',
    defaultMessage: 'Cancelled',
  },
  policyTagPending: {
    id: 'app.policy.tag.pending',
    defaultMessage: 'Pending',
  },
  policyTagExpired: {
    id: 'app.policy.tag.expired',
    defaultMessage: 'Expired',
  },
  // Add driver section
  documentAddDriverHeadline: {
    id: 'app.document.addDriver.headline',
    defaultMessage: 'Add driver',
  },
  documentRemoveDriverHeadline: {
    id: 'app.document.removeDriver.headline',
    defaultMessage: 'Remove driver',
  },
  documentAddDriverLabelFirstName: {
    id: 'app.document.addDriver.label.firstName',
    defaultMessage: 'First name',
  },
  documentAddDriverLabelLastName: {
    id: 'app.document.addDriver.label.lastName',
    defaultMessage: 'Last name',
  },
  documentAddDriverLabelDriverLicence: {
    id: 'app.document.addDriver.label.driverLicence',
    defaultMessage: 'Driver License #',
  },
  documentAddDriverLabelPhone: {
    id: 'app.document.addDriver.label.phone',
    defaultMessage: 'Phone #',
  },
  documentAddDriverLabelAddress: {
    id: 'app.document.addDriver.label.address',
    defaultMessage: 'Address',
  },

  documentAddDriverValidationFirstName: {
    id: 'app.document.addDriver.validation.firstName',
    defaultMessage: 'First name is required!',
  },
  documentAddDriverValidationLastName: {
    id: 'app.document.addDriver.validation.lastName',
    defaultMessage: 'Last name is required!',
  },
  documentAddDriverValidationDriverLicense: {
    id: 'app.document.addDriver.validation.driverLicense',
    defaultMessage: 'Driver license is required',
  },
  documentAddDriverValidationPhone: {
    id: 'app.document.addDriver.validation.phone',
    defaultMessage: 'Phone is required',
  },
  documentAddDriverValidationAddress: {
    id: 'app.document.addDriver.validation.address',
    defaultMessage: 'Address is required!',
  },

  // Remove driver
  documentRemoveDriverNoResults: {
    id: 'app.document.removeDriver.noResults',
    defaultMessage: 'No drivers found',
  },

  // Vechile section
  documentAddVehicleHeadline: {
    id: 'app.document.addVehicle.headline',
    defaultMessage: 'Add vehicle',
  },
  documentRemoveVehicleHeadline: {
    id: 'app.document.removeVehicle.headline',
    defaultMessage: 'Remove vehicle',
  },
  documentAddVehicleLabelYear: {
    id: 'app.document.addVehicle.label.year',
    defaultMessage: 'Year',
  },
  documentAddVehicleLabelMake: {
    id: 'app.document.addVehicle.label.make',
    defaultMessage: 'Make',
  },
  documentAddVehicleLabelModel: {
    id: 'app.document.addVehicle.label.model',
    defaultMessage: 'Model',
  },

  documentAddVehicleValidationYear: {
    id: 'app.document.addVehicle.validation.year',
    defaultMessage: 'Year is required!',
  },
  documentAddVehicleValidationMake: {
    id: 'app.document.addVehicle.validation.make',
    defaultMessage: 'Make is required!',
  },
  documentAddVehicleValidationModel: {
    id: 'app.document.addVehicle.validation.model',
    defaultMessage: 'Model is required!',
  },

  // Remove vehicle
  documentRemoveVehicleNoResults: {
    id: 'app.document.removeVehicle.noResults',
    defaultMessage: 'No vehicles found',
  },

  // Mail my pinkslip
  documentPinkSlipHeadline: {
    id: 'app.document.pinkslip.headline',
    defaultMessage: 'Mail my pink slip',
  },
  documentPinkSlipOtherAddress: {
    id: 'app.document.pinkslip.otherAddress',
    defaultMessage: 'Other address',
  },
  documentPinkSlipLabelAddress: {
    id: 'app.document.pinkslip.placeholder.address',
    defaultMessage: 'Address',
  },
  documentPinkSlipLabelCity: {
    id: 'app.document.pinkslip.placeholder.city',
    defaultMessage: 'City',
  },
  documentPinkSlipLabelState: {
    id: 'app.document.pinkslip.placeholder.state',
    defaultMessage: 'State',
  },
  documentPinkSlipLabelCountry: {
    id: 'app.document.pinkslip.placeholder.country',
    defaultMessage: 'Country',
  },
  documentPinkSlipLabelZip: {
    id: 'app.document.pinkslip.placeholder.zip',
    defaultMessage: 'Zip',
  },

  documentPinkSlipValidationAddress: {
    id: 'app.document.pinkslip.validation.address',
    defaultMessage: 'Address is required!',
  },
  documentPinkSlipValidationCity: {
    id: 'app.document.pinkslip.validation.city',
    defaultMessage: 'City is required!',
  },
  documentPinkSlipValidationState: {
    id: 'app.document.pinkslip.validation.state',
    defaultMessage: 'State is required!',
  },
  documentPinkSlipValidationCountry: {
    id: 'app.document.pinkslip.validation.country',
    defaultMessage: 'Country is required!',
  },
  documentPinkSlipValidationZip: {
    id: 'app.document.pinkslip.validation.zip',
    defaultMessage: 'Zip is required!',
  },

  // Actions
  documentLinkRemoveVehicle: {
    id: 'app.document.link.removeVehicle',
    defaultMessage: 'Remove Vehicle',
  },
  documentLinkAddVehicle: {
    id: 'app.document.link.addVehicle',
    defaultMessage: 'Add Vehicle',
  },
  documentLinkRemoveDriver: {
    id: 'app.document.link.removeDriver',
    defaultMessage: 'Remove Driver',
  },
  documentLinkAddDriver: {
    id: 'app.document.link.addVDriver',
    defaultMessage: 'Add Driver',
  },
  documentLinkShare: {
    id: 'app.document.link.share',
    defaultMessage: 'Share',
  },
  documentLinkAddToWallet: {
    id: 'app.document.link.addToWallet',
    defaultMessage: 'Add to wallet',
  },
  documentLinkDownload: {
    id: 'app.document.link.download',
    defaultMessage: 'Download',
  },

  // Consent
  documentConsentTitle: {
    id: 'app.document.consent.title',
    defaultMessage: 'Terms',
  },
  documentConsentErrorMessage: {
    id: 'app.document.consent.errorMessage',
    defaultMessage: 'Please accept the terms!',
  },

  documentsShowAll: {
    id: 'app.documents.showAll',
    defaultMessage: 'Show All',
  },
})
